// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Eqce","header":"MessagesList_header__3DrdZ","chat":"MessagesList_chat__2zWo9"};